// hooks/useReactionSound.ts
import { useCallback, useRef } from 'react';
import { ReactionType } from '@/lib/ReactionsContext'; // Ajuste o import conforme onde seu Context está

// Mapeamento baseado no seu print
const SOUND_MAP: Record<ReactionType, string> = {
  '👏': '/sounds/crowd-clapping-6-236777.mp3',
  '👍': '/sounds/bubble-pop-406640.mp3',     // Combina bem com Like
  '❤️': '/sounds/pop-402324.mp3',             // Pop suave para coração
  '😂': '/sounds/male-laugh-242216.mp3',
  '😮': '/sounds/wow-02-242639.mp3',
};

export function useReactionSound() {
  // Controle para evitar "metralhadora" de sons (Throttle)
  const lastPlayedRef = useRef<number>(0);

  const playSound = useCallback((emoji: ReactionType) => {
    const now = Date.now();
    // Limita a um som a cada 100ms para não virar bagunça
    if (now - lastPlayedRef.current < 100) return;

    const soundFile = SOUND_MAP[emoji];
    
    if (soundFile) {
      try {
        const audio = new Audio(soundFile);
        audio.volume = 0.4; // 40% do volume para não assustar
        audio.play().catch((e) => {
          // Navegadores as vezes bloqueiam autoplay se o usuário não interagiu com a página ainda
          console.warn("Audio play blocked", e);
        });
        lastPlayedRef.current = now;
      } catch (error) {
        console.error("Erro ao tocar som", error);
      }
    }
  }, []);

  return { playSound };
}